module.exports = __webpack_public_path__ + "img/re_pos.07e065fe.png";